var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewElementBtnSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FAA400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5382 60.4237C45.5382 57.6833 43.3167 55.4618 40.5763 55.4618L22.9618 55.4618C20.2215 55.4618 18 53.2403 18 50.5C18 47.7597 20.2215 45.5382 22.9618 45.5382L40.5763 45.5382C43.3167 45.5382 45.5382 43.3167 45.5382 40.5763V22.9618C45.5382 20.2215 47.7597 18 50.5 18C53.2403 18 55.4618 20.2215 55.4618 22.9618V40.5763C55.4618 43.3167 57.6833 45.5382 60.4237 45.5382L78.0382 45.5382C80.7785 45.5382 83 47.7597 83 50.5C83 53.2403 80.7785 55.4618 78.0382 55.4618H60.4237C57.6833 55.4618 55.4618 57.6833 55.4618 60.4237V78.0382C55.4618 80.7785 53.2403 83 50.5 83C47.7597 83 45.5382 80.7785 45.5382 78.0382V60.4237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewElementBtnSmall);
export default __webpack_public_path__ + "static/media/NewElementBtnSmall.e7b4ca51328063197ce69fc52738bd68.svg";
export { ForwardRef as ReactComponent };